import React from 'react'
import ProfileContainer from 'containers/panel/subreseller/profile-container'
const ProfilePage = () => {
  return (
    <ProfileContainer/>
  )
}

export default ProfilePage